import React from 'react';
import {useSelector} from 'react-redux';


import {BulkActionTool} from 'src/components/bulk-tool';
import {selectDataTableSelection} from 'src/components/data-table-selection/services/data-table-selection-slice';
import {
    bulkProductAssignUserEntitlements,
    getProductAssignUserEntitlementsProgress,
} from 'src/openapi/admin/apis/BulkProductAssignUserEntitlementsApi';
import {useAppDispatch} from 'src/store/hooks';

import Button from '@pb/kit-component-button';
import {useShown} from '@pb/kit-hooks-use-shown';

import {AssignProductUserEntitlementsModal} from './assign-product-user-entitlements.modal';
import {
    selectAssignProductUserEntitlementsBulkUuid,
    selectAssignProductUserEntitlementsTask,
    setBackgroundTask,
    setShown,
    setUuid,
} from './assign-product-user-entitlements.slice';
import {
    MODAL_WIDTH,
    TOOL_PROGRESS_LABEL,
    TOOL_STACK_OVERFLOW_MESSAGE,
    TOOL_TASK,
    TOOL_TITLE,
} from './constants';

import type {UpdateUserEntitlementsRelation} from 'src/openapi/admin/models/UpdateUserEntitlementsRelation';
import type {AppState} from 'src/store/typedef';

type Props = {
    userId: number,
    selectionKey: string,
    onDone: () => void,
};

export const AssignProductUserEntitlementsTool = ({selectionKey, onDone, userId}: Props) => {
    const apiDispatch = useAppDispatch();
    const {shown, onClick, onClose} = useShown();
    const selection = useSelector((state: AppState) => selectDataTableSelection(state, selectionKey));

    return (
        <>
            <Button disabled={!selection.ids.length} variant="Type.PRIMARY" onClick={onClick}>
                {TOOL_TITLE}
            </Button>
            <BulkActionTool<UpdateUserEntitlementsRelation>
                shown={shown}
                onClose={onClose}
                width={MODAL_WIDTH}

                toolTask={TOOL_TASK}
                toolName={TOOL_TITLE}
                progressLabel={TOOL_PROGRESS_LABEL}

                taskSelector={selectAssignProductUserEntitlementsTask}
                uuidSelector={selectAssignProductUserEntitlementsBulkUuid}

                setUuid={setUuid}
                setTask={setBackgroundTask}
                setResultShown={setShown}
                saveActionRequest={(updateUserEntitlementsRelation, options) => (
                    apiDispatch(bulkProductAssignUserEntitlements({...options, updateUserEntitlementsRelation}))
                )}
                getProgress={id => apiDispatch(getProductAssignUserEntitlementsProgress({id}))}

                stackOverflowMessage={TOOL_STACK_OVERFLOW_MESSAGE}
                onDone={onDone}>
                {({processAction, onCloseModal}) => (
                    <AssignProductUserEntitlementsModal
                        userId={userId}
                        ids={selection.ids}
                        onCloseModal={onCloseModal}
                        processAction={processAction}
                    />
                )}
            </BulkActionTool>
        </>
    );
};
